import React, { useState } from 'react';
import './Kontaktformular1.css';
import emailjs from 'emailjs-com';
import { useHistory } from 'react-router-dom';

function Kontaktformular1() {
  const history = useHistory();
  const [step, setStep] = useState(0);
  const NextStep = () => {
    if (step === 0) {
      if (
        inputField.name !== '' &&
        inputField.email !== '' &&
        inputField.tel !== ''
      ) {
        var $selector = document.getElementById('kontakt_button');
        $selector.classList.remove('deactive');
        setStep(step + 1);
      }
    } else if (step === 1) {
      if (inputField.produkt !== '' && inputField.aktion !== '') {
        setStep(step + 1);
      }
    }
  };

  const [inputField, setInputField] = useState({
    name: '',
    email: '',
    tel: '',
    produkt: '',
    aktion: '',
    kommentar: '',
  });

  const inputsHandler = (e) => {
    setInputField({ ...inputField, [e.target.name]: e.target.value });
    e.preventDefault();
    var $selector = document.getElementById('kontakt_button');
    if (step === 0) {
      if (
        inputField.name !== '' &&
        inputField.email !== '' &&
        inputField.tel !== ''
      ) {
        $selector.classList.remove('deactive');
      }
    } else if (step === 1) {
      if (
        (inputField.produkt !== '' ||
          (e.target.name === 'produkt' && e.target.value !== '')) &&
        (inputField.aktion !== '' ||
          (e.target.name === 'aktion' && e.target.value !== ''))
      ) {
        $selector.classList.remove('deactive');
      }
    } else {
      $selector.classList.remove('deactive');
    }
  };

  function sendEmail(e) {
    e.preventDefault();
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    today = dd + '.' + mm + '.' + yyyy;
    var message =
      '<html><head><link href="https://fonts.googleapis.com/css?family=Bungee+Inline" rel="stylesheet"></head>' +
      '<body style="font-family:verdana;">' +
      '<p>Einreichung:<span style="color:Blue;">Kontaktformular</span></p><p>Datum:<b>' +
      today +
      '</b></p>' +
      '<p>Name:<b>' +
      inputField.name +
      '</b></p><p>Email:<b>' +
      inputField.email +
      '</b></p>' +
      '<p>Telefonnummer:<b>' +
      inputField.tel +
      '</b></p>' +
      '<p>Produkt:<b>' +
      inputField.produkt +
      '</b></p>' +
      '<p>Aktion:<b>' +
      inputField.aktion +
      '</b></p><p>Weitere Informationen:</p><b>' +
      inputField.kommentar +
      '</b></body></html>';

    var templateParams = {
      titel: 'Kontaktformular',
      subject: '<span style="color:Blue;">Kontaktformular</span>',
      date: today,
      message: message,
      email: inputField.email,
    };

    try {
      emailjs
        .send(
          'service_i3gwto8',
          'template_rmhtdbw',
          templateParams,
          'user_m5XZtQ9ue6eZjf5XdkLvd'
        )
        .then(
          (res) => {
            console.log(res);
            history.push('/bestätigung');
          },
          (error) => {
            console.log(error.text);
          }
        );
    } catch (ex) {
      alert('error' + ex.message());
    }
    //setStep(0);
  }
  return (
    <div>
      {step === 0 ? (
        <>
          <div className="kontaktformular_1">
            <div className="kontaktformular_1_schritte">
              <h4 className="selected">Schritt 1</h4>
              <hr />
              <h4>Schritt 2</h4>
              <hr />
              <h4>Schritt 3</h4>
            </div>
            <div className="kontaktformular_1_title">
              <h1>Kontaktformular</h1>
              <p>Bitte geben Sie Ihre persönlichen Informationen ein.</p>
            </div>
            <div className="kontaktformular_1_formulare">
              <form
                method="POST"
                onSubmit={NextStep}
                id="contact-form"
                name="contact-form"
              >
                <label className="custom_field one">
                  <input
                    name="name"
                    onChange={inputsHandler}
                    type="text"
                    required
                  />
                  <span className="placeholder">Vor & Nachname</span>
                </label>
                <label className="custom_field one">
                  <input
                    type="text"
                    name="email"
                    onChange={inputsHandler}
                    required
                  />
                  <span className="placeholder">E-Mail Adresse</span>
                </label>
                <label className="custom_field one">
                  <input
                    type="text"
                    name="tel"
                    onChange={inputsHandler}
                    required
                  />
                  <span className="placeholder">Telefonnummer</span>
                </label>

                <button
                  className="deactive"
                  id="kontakt_button"
                  type="submit"
                  onClick={NextStep}
                >
                  Weiter
                </button>
              </form>
            </div>
          </div>
        </>
      ) : (
        <div>
          {step === 1 ? (
            <>
              {' '}
              <div className="kontaktformular_1">
                <div className="kontaktformular_1_schritte">
                  <h4>Schritt 1</h4>
                  <hr />
                  <h4 className="selected">Schritt 2</h4>
                  <hr />
                  <h4>Schritt 3</h4>
                </div>
                <div className="kontaktformular_1_title">
                  <h1>Produkt Auswählen</h1>
                  <p>Für welches Produkt interessieren Sie sich?</p>
                </div>
                <div className="kontaktformular_2_formulare">
                  <form
                    method="POST"
                    onSubmit={NextStep}
                    id="contact-form"
                    name="contact-form"
                  >
                    <select name="produkt" onChange={inputsHandler} required>
                      <option value="">Produkt auswählen</option>
                      <option value="Termion">Termion</option>
                      <option value="DentalPro">DentalPro</option>
                      <option value="Eos">Eos</option>
                      <option value="Telemedizin">Telemedizin</option>
                      <option value="Befundkarte">Befundkarte</option>
                      <option value="Notfallkarte">Notfallkarte</option>
                      <option value="Bookingdoc">Bookingdoc</option>
                    </select>

                    <p>Wie sollen wir Ihnen weiterhelfen?</p>

                    <select name="aktion" onChange={inputsHandler} required>
                      <option value="">Aktion auswählen</option>
                      <option value="Beratung">
                        Persönliches Beratungsgespräch
                      </option>
                      <option value="Rückruf">Rückruf</option>
                      <option value="Videoberatung">Videoberatung</option>
                      <option value="E-Mail">Informationen per E-Mail</option>
                    </select>

                    <button
                      className="deactive"
                      id="kontakt_button"
                      type="submit"
                      onClick={NextStep}
                    >
                      Weiter
                    </button>
                  </form>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="kontaktformular_1">
                <div className="kontaktformular_1_schritte">
                  <h4>Schritt 1</h4>
                  <hr />
                  <h4>Schritt 2</h4>
                  <hr />
                  <h4 className="selected">Schritt 3</h4>
                </div>
                <div className="kontaktformular_1_title">
                  <h1>Letzter Schritt</h1>
                  <p>
                    Wollen Sie uns noch zusätzliche Informationen mitteilen?
                  </p>
                </div>
                <div className="kontaktformular_1_formulare">
                  <form
                    method="POST"
                    onSubmit={sendEmail}
                    id="contact-form"
                    name="contact-form"
                  >
                    <label>
                      <textarea
                        name="kommentar"
                        onChange={inputsHandler}
                        className="textbox"
                        type="text"
                        placeholder="Geben Sie hier Ihre Wünsche bekannt..."
                      />
                    </label>

                    <button
                      id="kontakt_button"
                      type="submit"
                      onClick={sendEmail}
                    >
                      Absenden
                    </button>
                  </form>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default Kontaktformular1;
